import axios from "axios";
import { MessageBox, Message } from "element-ui";
import store from "@/store";
import signature from "@/utils/signature";

// create an axios instance
// axios.defaults.headers['sign'] = store.state.headerSign
function setHdr() {
  let hdLocTime = Date.parse(new Date());
  let timeStamp = hdLocTime + store.state.timeGap;
  let plf = "email";
  let token = localStorage.getItem("accessToken");
  // console.log('tokennnnn',token)
  // console.log('本地',localStorage.getItem('accessToken'))
  let signData = "token=" + token + "&platform=" + plf + "&time=" + timeStamp;
  let signa = signature.Encrypt(signData);
  // signature.Encrypt(signData);
  return signa;

  // console.log("加密", signa);
  // let designa = signature.Decrypt(signa);
  // console.log("解密", designa);
  // this.$store.commit("setHeader", signa);
}
let sign = setHdr();
const service = axios.create({
  baseURL: "https://www.king-arts.com", // url = base url + request url
  // baseURL: 'https://guanting.pandashopkeeper.com', // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 50000, // request timeout
  headers: {
    sign: setHdr(),
    "Content-Type": "application/x-www-form-urlencoded"
  }
});

// service.headers = {
//   'application/json': "application/x-www-form-urlencoded"
// }
// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    if (localStorage.getItem("accessToken")) {
      // let each request carry token
      // ['X-Token'] is a custom headers key
      // please modify it according to the actual situation
      config.headers["sign"] = setHdr();
    }
    return config;
  },
  error => {
    // do something with request error
    console.log(error); // for debug
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(
  /**
   * If you want to get http information such as headers or status
   * Please return  response => response
   */

  /**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
  response => {
    const res = response.data;

    // if the custom code is not 20000, it is judged as an error.
    if (res.code !== 200 && res.code !== 500) {
      console.log(res);
      if (store.state.conty == "zh-cn") {
        Message({
          message: res.msg || "Error",
          type: "warning",
          duration: 5 * 1000
        });
      } else if (store.state.conty == "zh-hk") {
        Message({
          message: res.error["zh-hk"] || "Error",
          type: "warning",
          duration: 5 * 1000
        });
      } else {
        Message({
          message: res.error["eng"] || "Error",
          type: "warning",
          duration: 5 * 1000
        });
      }

      // console.log(res)
      // 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
      if (res.code === 4001) {
        // to re-login
        return res;
      }
      return Promise.reject(new Error(res.message || "Error"));
    } else {
      return res;
    }
  },
  error => {
    console.log("err" + error); // for debug
    // Message({
    //   message: error.message,
    //   type: "error",
    //   duration: 5 * 1000
    // });
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/utils/request.js